module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "universal-card"
  }, [_c('div', {
    staticClass: "universal-card__body"
  }, [_c('AppPicture', {
    staticClass: "universal-card__pic",
    attrs: {
      "alt": _vm.item.vacancy_name,
      "image": _vm.item.partner_logo,
      "placeholder-image": _vm.placeholder,
      "fit-mode": "contain"
    }
  }), _c('div', {
    staticClass: "universal-card__block"
  }, [(_vm.item.organization_name) ? _c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v(_vm._s(_vm.item.organization_name))]) : _vm._e(), (_vm.item.actual_vacancy_name) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Вакансия: "), _c('strong', [_vm._v(_vm._s(_vm.item.actual_vacancy_name))])]) : _vm._e(), (_vm.item.organization_address) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Адрес организации: "), _c('strong', [_vm._v(_vm._s(_vm.item.organization_address))])]) : _vm._e(), (_vm.item.contact_person) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Контактное лицо: "), _c('strong', [_vm._v(_vm._s(_vm.item.contact_person))])]) : _vm._e(), (_vm.item.phone) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Телефон: "), _c('strong', [_vm._v(_vm._s(_vm.item.phone))])]) : _vm._e(), (_vm.item.email) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Электронная почта: "), _c('strong', [_vm._v(_vm._s(_vm.item.email))])]) : _vm._e(), (_vm.item.description) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Описание: "), _c('strong', [_vm._v(_vm._s(_vm.item.description))])]) : _vm._e(), (_vm.item.date) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Дата: "), _c('strong', [_vm._v(_vm._s(_vm.item.date))])]) : _vm._e(), (_vm.item.time) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Время: "), _c('strong', [_vm._v(_vm._s(_vm.item.time))])]) : _vm._e()], 1), (_vm.item.is_published) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('AppButtonNew', {
    staticClass: "ms-md-auto ui_color__white",
    staticStyle: {
      "flex": "1 0 auto"
    },
    attrs: {
      "to": _vm.linkToVacancy
    }
  }, [_vm._v("Открыть страницу вакансии")])], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-228d7314","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/InterviewCard/InterviewCard.vue
// module id = ad23e62b0b3a80f94268
// module chunks = 89